import React, { useEffect, useState, useRef } from "react"
import './App.scss'
import moment from 'moment'
import axios from 'axios'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPrint, faTrash } from "@fortawesome/free-solid-svg-icons"
import { useReactToPrint } from 'react-to-print'
import { sha256 } from 'js-sha256'
import Select from 'react-select'
import Header from "./components/header"
import Etiquette from "./components/etiquette"

export const Entree = () => {

  const componentRef = useRef()
  const selectInputRef = useRef()
  const selectInputCo = useRef()
  const selectInputCa = useRef()
  const selectInputFa = useRef()
  const metrageRef = useRef()
  const hash = sha256(process.env.REACT_APP_HMSG)
  const [loading, setLoading] = useState(false)
  const [reload, setReload] = useState(false)

  const [form, setForm] = useState({
    idcarton: 0,
    fournisseur: "",
    fournisseurLibelle: "",
    famille: "",
    couleur: "",
    casier: "",
    idbaguette: "",
    longueur: 0,  //longueur d'une baguette dans le carton
    nombre: 0,    //nombre de baguette dans le carton
    metrage: 0,   //métrage total dans le carton
    date: moment(new Date()).format('DD/MM/Y'),
  })

  const [base, setBase] = useState({
    baguette: "",
    famille: "",
    couleur: "",
    casier: "",
    idcarton: "",
  })

  const [option, setOption] = useState({
    couleur: [],
    ref: [],
    famille: [],
    casier: [],
  })

  const resetForm = (event = null) => {
    if (event !== null) {
      event.preventDefault()
    }
    selectInputRef.current.select.clearValue()
    selectInputCo.current.select.clearValue()
    selectInputCa.current.select.clearValue()
    selectInputFa.current.select.clearValue()
    setForm({
      ...form,
      idcarton: 0,
      fournisseur: "",
      fournisseurLibelle: "",
      famille: "",
      couleur: "",
      casier: "",
      idbaguette: "",
      longueur: 0,
      nombre: 0,
      metrage: 0,
      date: moment(new Date()).format('DD/MM/Y'),
    })
    SetSelectForm(base)
  }

  const SetSelectForm = data => {
    let keyCo = []
    let keyRef = []
    let keyFa = []
    let keyCa = []
    let datares = data
    datares.couleur.forEach((element) => {
      keyCo.push({ value: element.co_id, label: element.co_libelle, name: "couleur" })
    })
    datares.famille.forEach((element) => {
      keyFa.push({ value: element.fa_id, label: element.fa_libelle, name: "famille" })
    })
    datares.casier.forEach((element) => {
      keyCa.push({ value: element.ca_id, label: element.ca_libelle, name: "casier" })
    })
    datares.baguette.forEach((element) => {
      keyRef.push({ value: element.ba_id, label: element.ba_ref_fournisseur, name: "fournisseur", couleur: element.ba_fk_id_couleur, famille: element.ba_fk_id_famille, casier: element.ba_fk_id_casier, fournisseurLibelle: element.fo_libelle })
    })

    if (keyRef.length === 1) {
      setForm({
        ...form,
        fournisseur: keyRef[0].label,
        idbaguette: keyRef[0].value,
        couleur: keyRef[0].couleur,
        famille: keyRef[0].famille,
        casier: keyRef[0].casier,
        fournisseurLibelle: keyRef[0].fournisseurLibelle,
      })
    } else if (keyCa.length === 1 && keyCo.length === 1) {
      setForm({
        ...form,
        casier: keyCa[0].value,
        couleur: keyCo[0].value,
      })
    } else if (keyCa.length === 1) {
      setForm({
        ...form,
        casier: keyCa[0].value,
      })
    } else if (keyCo.length === 1) {
      setForm({
        ...form,
        couleur: keyCo[0].value,
      })
    }

    setOption({ couleur: keyCo, ref: keyRef, famille: keyFa, casier: keyCa })
  }

  useEffect(() => {
    if (typeof window !== "undefined" && (base.baguette === "" || reload)) {
      axios.get(`${process.env.REACT_APP_API_URL}/stock/listeDepart?talk=${hash}`)
        .then(({ data }) => {
          SetSelectForm(data)
          setBase({
            ...base,
            baguette: data.baguette,
            famille: data.famille,
            couleur: data.couleur,
            casier: data.casier,
            idcarton: data.maxidcarton,
          })
          setReload(false)
        })
        .catch(function (error) {
          console.log(error)
          alert("Erreur de communication avec la base !")
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base, hash, reload])

  //select change
  const handleInputChange = event => {
    if (event !== null) {
      if (event.name === "famille") {
        let casierArray = []
        base.baguette.filter(b => b.ba_fk_id_famille === event.value).map(b => b.ba_fk_id_famille !== null && casierArray.indexOf(b.ba_fk_id_casier) === -1 ? casierArray.push(b.ba_fk_id_casier) : "")
        let couleurArray = []
        base.baguette.filter(b => b.ba_fk_id_famille === event.value).map(b => b.ba_fk_id_couleur !== null && couleurArray.indexOf(b.ba_fk_id_couleur) === -1 ? couleurArray.push(b.ba_fk_id_couleur) : "")
        SetSelectForm(
          {
            ...base,
            baguette: base.baguette.filter(b => b.ba_fk_id_famille === event.value),
            casier: base.casier.filter(c => casierArray.includes(c.ca_id)),
            couleur: base.couleur.filter(co => couleurArray.includes(co.co_id)),
          })
      } else if (event.name === "couleur") {
        let casierArray = []
        base.baguette.filter(b => b.ba_fk_id_couleur === event.value).map(b => b.ba_fk_id_famille !== null && casierArray.indexOf(b.ba_fk_id_casier) === -1 ? casierArray.push(b.ba_fk_id_casier) : "")
        let familleArray = []
        base.baguette.filter(b => b.ba_fk_id_couleur === event.value).map(b => b.ba_fk_id_famille !== null && familleArray.indexOf(b.ba_fk_id_famille) === -1 ? familleArray.push(b.ba_fk_id_famille) : "")
        SetSelectForm(
          {
            ...base,
            baguette: base.baguette.filter(b => b.ba_fk_id_couleur === event.value),
            famille: base.famille.filter(f => familleArray.includes(f.fa_id)),
            casier: base.casier.filter(c => casierArray.includes(c.ca_id)),
          })
      } else if (event.name === "casier") {
        let familleArray = []
        base.baguette.filter(b => b.ba_fk_id_casier === event.value).map(b => b.ba_fk_id_famille !== null && familleArray.indexOf(b.ba_fk_id_famille) === -1 ? familleArray.push(b.ba_fk_id_famille) : "")
        let couleurArray = []
        base.baguette.filter(b => b.ba_fk_id_casier === event.value).map(b => b.ba_fk_id_couleur !== null && couleurArray.indexOf(b.ba_fk_id_couleur) === -1 ? couleurArray.push(b.ba_fk_id_couleur) : "")
        SetSelectForm(
          {
            ...base,
            baguette: base.baguette.filter(b => b.ba_fk_id_casier === event.value),
            famille: base.famille.filter(f => familleArray.includes(f.fa_id)),
            couleur: base.couleur.filter(co => couleurArray.includes(co.co_id)),
          })
      } else if (event.name === "fournisseur") {
        setForm({
          ...form,
          fournisseur: event.label,
          idbaguette: event.value,
          couleur: event.couleur,
          famille: event.famille,
          casier: event.casier,
          fournisseurLibelle: event.fournisseurLibelle,
        })
        metrageRef.current.focus()
      } else {
        setForm({ ...form, [event.name]: event.value })
      }
    }
  }

  //input change
  const handleUpdate = event => {
    if (event.target.name === "longueur" && form.nombre > 0) {
      setForm({ ...form, metrage: event.target.value * form.nombre, [event.target.name]: event.target.value })
    } else if (event.target.name === "nombre" && form.longueur > 0) {
      setForm({ ...form, metrage: event.target.value * form.longueur, [event.target.name]: event.target.value })
    } else {
      setForm({ ...form, [event.target.name]: event.target.value })
    }
  }

  const handleSubmit = event => {
    event.preventDefault()
    setLoading(true)
  }

  const GetFamille = (idSearch) => {
    if (base && base.famille !== null && idSearch) {
      return base.famille.find(f => f.fa_id === idSearch).fa_libelle
    }
  }

  const GetColor = (idSearch) => {
    if (base && base.couleur !== null && idSearch) {
      return base.couleur.find(co => co.co_id === idSearch).co_libelle
    }
  }

  const GetCasier = (idSearch) => {
    if (base && base.casier !== null && idSearch) {
      return base.casier.find(ca => ca.ca_id === idSearch).ca_libelle
    }
  }

  const BeforePrint = (resolve, reject) => {
    if (form.metrage > 0 && form.idbaguette !== "") {
      axios.post(`${process.env.REACT_APP_API_URL}/stock/sendCarton?talk=${hash}`, {
        idbag: parseInt(form.idbaguette),
        nbbag: parseInt(form.nombre),
        longbag: parseInt(form.longueur),
        metbag: parseInt(form.metrage),
      })
        .then(function (response) {
          if (response.status === 200) {
            resolve()
          } else {
            reject()
          }
        })
        .catch(function (error) {
          console.log(error)
          reject()
        });
      return
    } else {
      reject()
    }
  }

  const AfterPrint = () => {
    resetForm()
    setLoading(false)
    setReload(true)
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => AfterPrint(),
    onBeforePrint: async () =>
      await new Promise((resolve, reject) => {
        BeforePrint(resolve, reject);
      })
  })

  return (
    <>
      <Header />
      <div className="noprint">
        <div className="hero pattern-zigzag-light" style={{ marginTop: -4 }}>
          <div className="hero-body">
            <div className="container has-text-centered">
              <h1 className="title is-2 has-text-centered dreamland">Entrée</h1>
            </div>
          </div>
        </div>
        <div className="container is-fluid pb-5 pattern-cross-dots">
          <div className="columns is-centered login">
            <div className="column couleurShadow">
              <div className="box">
                <form method="post" onSubmit={event => handleSubmit(event)}>
                  <h2 className="is-size-4 mb-4" style={{ color: "#7e421e", paddingBottom: 5, borderBottom: "1px solid #ccc" }}>Saisie</h2>
                  <div className="field is-hidden">
                    <label disabled className="label" htmlFor="idcarton">
                      Id carton&nbsp;:
                        </label>
                    <div className="control">
                      <input type="text" id="idcarton" name="idcarton" onChange={e => handleUpdate(e)} disabled value={base.idcarton} className="input" />
                    </div>
                  </div>
                  <div className="columns">
                    <div className="column">
                      <div className="field">
                        <label className="label" htmlFor="fournisseur">
                          Ref. fournisseur&nbsp;:
                        </label>
                        <div className="control">
                          <Select
                            isClearable={true} id="fournisseur" name="fournisseur"
                            placeholder="Ref. fournisseur" className="input searchMap" ref={selectInputRef}
                            onChange={e => handleInputChange(e)}
                            options={option.ref}
                            value={option.ref.find(option => parseInt(option.value) === parseInt(form.idbaguette))}
                            noOptionsMessage={() => "Aucun résultat"}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label className="label" htmlFor="casier">
                          Casier&nbsp;:
                        </label>
                        <div className="control">
                          <Select
                            isClearable={true} id="casier" name="casier"
                            placeholder="Casier" className="input searchMap" ref={selectInputCa}
                            onChange={e => handleInputChange(e)}
                            options={option.casier}
                            value={option.casier.find(option => option.value === form.casier)}
                            noOptionsMessage={() => "Aucun résultat"}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label className="label" htmlFor="famille">
                          Famille&nbsp;:
                        </label>
                        <div className="control">
                          <Select
                            isClearable={true} id="famille" name="famille"
                            placeholder="Famille" className="input searchMap" ref={selectInputFa}
                            onChange={e => handleInputChange(e)}
                            options={option.famille}
                            value={option.famille.find(option => option.value === form.famille)}
                            noOptionsMessage={() => "Aucun résultat"}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label className="label" htmlFor="couleur">
                          Couleur&nbsp;:
                        </label>
                        <div className="control">
                          <Select
                            isClearable={true} id="couleur" name="couleur"
                            placeholder="Couleur" className="input searchMap" ref={selectInputCo}
                            onChange={e => handleInputChange(e)}
                            options={option.couleur}
                            value={option.couleur.find(option => option.value === form.couleur)}
                            noOptionsMessage={() => "Aucun résultat"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="column">
                      <div className="field is-hidden">
                        <label className="label" htmlFor="idbaguette">
                          Id baguette&nbsp;:
                        </label>
                        <div className="control">
                          <input type="text" id="idbaguette" name="idbaguette" value={form.idbaguette} disabled onChange={e => handleUpdate(e)} className="input" />
                        </div>
                      </div>
                      <div className="field">
                        <label className="label" htmlFor="longueur">
                          Longueur de baguette&nbsp;:
                        </label>
                        <div className="control">
                          <input type="number" id="longueur" name="longueur" step="1" onChange={e => handleUpdate(e)} value={form.longueur} className="input" placeholder="Longueur de baguette" min="0" max="1000000" autoComplete="off" />
                        </div>
                      </div>
                      <div className="field">
                        <label className="label" htmlFor="nombre">
                          Nombre de baguette&nbsp;:
                        </label>
                        <div className="control">
                          <input type="number" id="nombre" name="nombre" step="1" onChange={e => handleUpdate(e)} value={form.nombre} className="input" placeholder="Nombre de baguette" min="0" max="1000000" autoComplete="off" />
                        </div>
                      </div>
                      <div className="field">
                        <label className="label" htmlFor="metrage">
                          Métrage total&nbsp;:
                        </label>
                        <div className="control">
                          <input type="number" id="metrage" name="metrage" step="1" onChange={e => handleUpdate(e)} required value={form.metrage} ref={metrageRef} className="input" placeholder="Métrage total" min="1" max="1000000" autoComplete="off" />
                        </div>
                      </div>
                      <div>
                      </div>
                      <div className="columns" style={{ paddingTop: "30px" }}>
                        <div className="column field has-text-centered" >
                          <button onClick={e => resetForm(e)} className={`button is-warning is-light is-medium ${loading ? `is-loading` : ``} `} >
                            <FontAwesomeIcon icon={faTrash} className="mr-2" /> Réinitialiser le formulaire
                          </button>
                        </div>
                        <div className="column has-text-right">
                          <button type="submit" onClick={handlePrint} className={`button is-primary is-light is-medium ${loading ? `is-loading` : ``}  ${form.metrage > 0 && form.idbaguette !== "" ? `` : `is-hidden`}`} >
                            <FontAwesomeIcon icon={faPrint} className="mr-2" /> Imprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref={componentRef}>
        <Etiquette idcarton={base.idcarton} idbaguette={form.idbaguette} fournisseur={form.fournisseur} nombre={form.nombre} longueur={form.longueur} metrage={form.metrage} famille={form.famille} couleur={form.couleur} casier={form.casier} fournisseurLibelle={form.fournisseurLibelle} familleLibelle={GetFamille(form.famille)} couleurLibelle={GetColor(form.couleur)} casierLibelle={GetCasier(form.casier)} date={form.date} />
      </div>
    </>
  )
}

export default Entree
